/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import CurrencyValue from './CurrencyValue';
import GoToCurrencySettings from './GoToCurrencySettings';
import UIList from 'UIComponents/list/UIList';
import { getNameFromCurrencySymbol, getCurrencySymbol } from 'AdsUI/lib/Utils';
import AdSpendCurrencyChoiceLink from './AdSpendCurrencyChoiceLink';

const CostPerMetric = ({
  column,
  value: {
    amount,
    currencyCode
  },
  divisor,
  inconvertibleCurrencies
}) => /*#__PURE__*/_jsx(UITooltip, {
  use: "longform",
  title: !!divisor && inconvertibleCurrencies && inconvertibleCurrencies.length && /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.multiCurrencyTooltip.currencies",
        options: {
          column
        }
      })
    }), /*#__PURE__*/_jsx(UIList, {
      styled: true,
      children: inconvertibleCurrencies.map(currency => /*#__PURE__*/_jsx("span", {
        children: getNameFromCurrencySymbol(currency)
      }, currency))
    }), /*#__PURE__*/_jsx(GoToCurrencySettings, {
      textKey: "setUpConversion"
    }), /*#__PURE__*/_jsx(AdSpendCurrencyChoiceLink, {
      block: true
    })]
  }),
  disabled: !divisor || !inconvertibleCurrencies || !inconvertibleCurrencies.length,
  children: /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(CurrencyValue, {
      value: amount,
      currencySymbol: getCurrencySymbol(currencyCode)
    })
  })
});

CostPerMetric.propTypes = {
  column: PropTypes.string.isRequired,
  value: PropTypes.shape({
    amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    currencyCode: PropTypes.string
  }).isRequired,
  divisor: PropTypes.number
};
export default CostPerMetric;